import { Fragment } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Combobox, HookForm } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { notificationSuccess } from 'app/core/toast';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { ObjectRequired } from '../../../../../core/validations/common';
import { useOperationsList } from '../../../../Operations/EconomyActivity/hooks/useOperationsList';
import { type OperationReportRequest, type ReportVector } from '../../models/types';
import { useGetAllReports } from '../../services/hooks';
import { saveReportOperation } from '../../services/http';
import { label } from '../../translation';

const validations = yup.object().shape({
  operation: ObjectRequired,
  report: ObjectRequired
});

const Index = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const [{ data: operations, loading: loadingOperations, error: errroOperations }] =
    useOperationsList();

  const { data: reports, loading: loadingReports, error: errorReports } = useGetAllReports();

  const save = async (report: ReportVector) => {
    try {
      await saveReportOperation({
        operationId: report.operation.id,
        reportId: report.report.id
      } as OperationReportRequest);
      notificationSuccess(i18next.t('taxes.messages.savedSuccessfully'));
      navigate('/taxes/manage/reports');
    } catch (e) {
      console.error(e);
    }
  };

  const onCancel = () => {
    navigate('/taxes/manage/reports');
  };

  if (loadingOperations || errroOperations || loadingReports || errorReports) {
    return <></>;
  }

  return (
    <Fragment>
      <HookForm initialValues={{}} validations={validations} onSubmit={save}>
        <Row>
          <Col>
            <Combobox
              label={label('report')}
              name="report"
              display="name"
              code="id"
              data={reports}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Combobox
              label={label('operation')}
              name="operation"
              display="name"
              code="id"
              data={operations}
            />
          </Col>
        </Row>

        <BtnToolbar>
          <BtnGroup>
            <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
          </BtnGroup>
          <BtnGroup>
            <Button action={ButtonAction.save} variant="primary" type={'submit'} />
          </BtnGroup>
        </BtnToolbar>
      </HookForm>
    </Fragment>
  );
};

export default Index;
